module.exports = __webpack_public_path__ + "public/images/header/close-cross.54548d2920e2149e2188513c3ef31076.svg";